import i18n from 'modules/core/lib/i18n'

import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'

export interface StatusCounts {
  draft?: number
  pending?: number
  approved?: number
  paid?: number
}

interface StatusCountsResult {
  data: StatusCounts | undefined
  loading: boolean
}

interface UseExpensesPresetsConfigOptions {
  includeDraft?: boolean
  statusCounts?: StatusCountsResult
  showDateNavigation?: boolean
}

const emptyNavigationFilters: Record<string, never> = {}

export const useExpensesPresetsConfig = (options: UseExpensesPresetsConfigOptions = {}) => {
  const { includeDraft = true, statusCounts, showDateNavigation = true } = options
  const { dateFilters } = usePageDateFilters()

  const navigationFilters = showDateNavigation
    ? {
        date: {
          defaultGranularity: 'range' as const,
          defaultValue: {
            from: dateFilters.startDate,
            to: dateFilters.endDate,
          },
          granularity: ['day', 'week', 'month', 'year', 'range'],
          type: 'date-navigator' as const,
        },
      }
    : emptyNavigationFilters

  const counts = statusCounts?.data
  const presets = [
    ...(includeDraft
      ? [
          {
            label: i18n.t('expenses_v2.expense.status.draft'),
            filter: { status: ['draft'] },
            itemsCount: () => counts?.draft,
          },
        ]
      : []),
    {
      label: i18n.t('expenses_v2.expense.status.pending'),
      filter: { status: ['pending'] },
      itemsCount: () => counts?.pending,
    },
    {
      label: i18n.t('expenses_v2.expense.status.approved'),
      filter: { status: ['approved'] },
      itemsCount: () => counts?.approved,
    },
    {
      label: i18n.t('expenses_v2.expense.status.paid'),
      filter: { status: ['in_payroll', 'sent_to_pay', 'paid'] },
      itemsCount: () => counts?.paid,
    },
  ]

  return { navigationFilters, presets, presetsLoading: statusCounts?.loading ?? false }
}
